import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "store/baseUrls";
import type { RootState } from "..";
import type { Result } from "store/api.type";
import type { Genre } from "./genre.model";
import type { Track } from "store/track/track.model";
import {Playlist} from "../playlist/playlist.model";

export const genreApi = createApi({
  reducerPath: "genreApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Accept", "application/json");
      headers.set("X-Api-Key", "4872bafc54269b2a7133705ab32c7e69");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getGenre: builder.query<Genre, { genreId: string}>({
      query: ({genreId}) => `/v1/genre/${genreId}`,
      transformResponse: (data: Genre) => data,
    }),
    getGenres: builder.query<Genre[], void>({
      query: () => "/v1/genre",
      transformResponse: (data: Result<Genre>) => data.list,
    }),
    getGenreTracks: builder.query<
      Track[],
      { genreId: string; offset?: number; limit?: number }
    >({
      query: ({ genreId, offset = 0, limit = 20 }) =>
        `/v1/genre/${genreId}/tracks?offset=${offset}&maxSize=${limit}`,
      transformResponse: (data: Result<Track>) => data.list,
    }),
    getGenrePlaylists: builder.query<
        Playlist[],
        { genreId: string}
        >({
      query: ({ genreId}) =>
          `/v1/genre/${genreId}/playlists`,
      transformResponse: (data: Result<Playlist>) => data.list,
    }),
  }),
});

export const {
  useGetGenreQuery,
  useGetGenresQuery,
  useGetGenreTracksQuery,
  useGetGenrePlaylistsQuery,
  util: genreApiUtil,
} = genreApi;
